<template>
  <div class="atom-input-select-object">
    <select
      :class="{ 'select--validation-error': error }"
      v-model="inputValue"
      :id="id"
      @enter="emitEnter"
      @change="change"
    >
      <option value="">{{ placeholder }}</option>
      <option v-for="v in options" :key="v.id" :value="v.id">{{ v.name[$i18n.locale] }}</option>
    </select>

    <span class="atom-input-select__value">{{ selectName[$i18n.locale] || placeholder }}</span>

    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.93933 6L7.76256 11.8232C8.44597 12.5066 9.55401 12.5066 10.2374 11.8232L16.0607 6H13.9393L9.17677 10.7626C9.07914 10.8602 8.92085 10.8602 8.82321 10.7626L4.06065 6H1.93933Z"
          fill="black"
        />
      </g>
    </svg>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

interface selectDataNameType {
  ja: string
  en: string
}
interface selectDataType {
  name: selectDataNameType
  id: string
}

/**
 * 汎用セレクトフィールド
 * todo: error / disabled 時デザイン
 */
export default defineComponent({
  name: 'AtomInputSelectObject',
  props: {
    /**
     * ID
     */
    id: {
      type: String,
      default: '',
    },
    /**
     * Value値
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * 選択肢
     */
    options: {
      type: Array as () => selectDataType[],
      default: () => [],
    },
    /**
     * Error判定
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * プレースホルダー
     */
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    /**
     * country
     * @param {string} val 国
     */
    const inputValue = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })
    return {
      inputValue,
    }
  },
  data() {
    return {
      selectName:
        this.options.find((item) => item.id === this.value)?.name ||
        ({ ja: '', en: '' } as selectDataNameType),
    }
  },
  watch: {
    inputValue: {
      handler() {
        this.selectName =
          this.options.find((item) => item.id === this.inputValue)?.name ||
          ({ ja: '', en: '' } as selectDataNameType)
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 選択が変更されたことを通知する
     */
    change() {
      /**
       * 選択が変更されたことを通知する
       * @event change
       * @type {Object}
       */
      this.$emit('change')
    },
    /**
     * エンターキーが押されたことを通知する
     */
    emitEnter() {
      /**
       * エンターキーが押されたことを通知する
       * @event enter
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>

<style lang="scss" scoped>
.atom-input-select-object {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 2.769em;
  padding: 0.615em 0.923em 0.615em 0.692em;
  text-align: left;
  appearance: none;
  outline: none;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #c7c7c7;
  backdrop-filter: blur(0.85em);
  color: $gray50;

  select {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    opacity: 0;
  }

  svg {
    pointer-events: none;
  }

  &__value {
    display: block;
    width: calc(100% - 20px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    pointer-events: none;
  }
}
</style>
